.input {
  --ixf-input-placeholder-color: var(--ixf-color-neutral-dk);
  --ixf-input-padding-vertical: var(--ixf-space-3);
  --ixf-input-padding-horizontal: var(--ixf-space-4);
  --ixf-input-padding: var(--ixf-input-padding-vertical)
    var(--ixf-input-padding-horizontal);
  --ixf-input-font-size: 0.875rem;
  --ixf-input-line-height: 1.125rem;
  --ixf-input-height: 48px;
  --ixf-input-font-family: var(--ixf-font-family-main);
  --ixf-input-font-color: var(--ixf-text-tone-md);
  --ixf-input-font-weight: var(--ixf-font-weight-main-medium);
  --ixf-input-border-weight: 1px;
  --ixf-input-border-radius: var(--ixf-border-radius-2);
  --ixf-input-border-color: var(--ixf-color-separator);
  --ixf-input-error-color: var(--ixf-color-danger-dk);
  --ixf-input-label-active-offset: 8px;
  --ixf-input-label-active-offset-horizontal: 0;
  --ixf-input-label-gap: var(--ixf-space-1);
  --ixf-input-disabled-opacity: 0.6;

  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  &.isDisabled {
    opacity: var(--ixf-input-disabled-opacity);
  }

  .activator,
  .field {
    z-index: 1;
    height: var(--ixf-input-height);
  }
}
